export default __webpack_public_path__ + "static/media/sequenceShared1.6803ade6.png";